import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import renderHTML from 'react-render-html';
import {getClassName} from '../../utils';

import './message.component.scss';

const styles = {};

/**
 * Message Component
 * @param {string} props.type
 * @param {string} props.message
 * @param {array} props.buttons
 */
class Message extends Component {

    /**
     * Render Action Button
     * @param button
     * @param index
     */
    renderActionButton = (button, index) => {
        const {theme, icon, label, onClick, disabled} = button;

        const buttonClass = getClassName('button button--tall', [
            {condition: theme, trueClassName: `button--${theme}`},
            {condition: (icon && !(label && label.length)), trueClassName: 'button--square'}
        ]);

        return (
            <button key={`message-button--${index}`} className={buttonClass} onClick={onClick} disabled={disabled}>
                {icon && <i className={`button_icon ${icon}`}/>}
                {label}
            </button>
        );
    };

    /**
     * Render Message Component
     * @return {XML}
     */
    render() {
        const {visible, type, title, message, children, useHtml, buttons, onClose, renderExitButton, className} = this.props;

        return (
            <Dialog
                className={className ? `message-root ${className}` : 'message-root'}
                classes={{
                    paper: `message message--${type}`
                }}
                open={!!visible}
                onClose={onClose}>
                <div className='message_content'>
                    <h1 className='message_title'>{useHtml ? renderHTML(title) : title}</h1>
                    <div className='message_text'>{useHtml ? renderHTML(message) : message}</div>
                    {children}
                </div>
                {(buttons && buttons.length > 0) && (
                    <footer className='message_footer'>
                        <div className='message_actions'>
                            {buttons.map(this.renderActionButton)}
                        </div>
                    </footer>
                )}
                {renderExitButton &&  (
                    <div className='message_exit' onClick={onClose}>
                        <i className='q4i-close-4pt'/>
                    </div>
                )}
            </Dialog>
        );
    }
}

export default withStyles(styles)(Message);
